import React from 'react';
import './styles/App.scss';
import { FirebaseProvider } from './providers/firebase/FirebaseProvider';
import { DataProvider } from './providers/data/DataProvider';
import { GloabalStateProvider } from './providers/globalState/GlobalStateProvider';
import StepsView from './components/steps/stepsView';
import { StaticTextProvider } from './providers/staticText/staticTextProvider';
import { BrowserRouter } from 'react-router-dom';
import { MetaPixelProvider } from './providers/metaPixel/MetaPixelProvider';
import { AnalyticsProvider } from './providers/analytics/AnalyticsProvider';
import { TikTokPixelProvider } from './providers/tiktokPixel/TikTokPixelProvider';
import { BIServiceProvider } from './providers/bi/BIServiceProvider';


function App() {


  return (
    <BrowserRouter>
      <FirebaseProvider>
        <AnalyticsProvider>
          <MetaPixelProvider>
            <TikTokPixelProvider>
              <DataProvider>
                <StaticTextProvider>
                  <BIServiceProvider>
                    <GloabalStateProvider>
                      <StepsView />
                    </GloabalStateProvider>
                  </BIServiceProvider>
                </StaticTextProvider>
              </DataProvider>
            </TikTokPixelProvider>
          </MetaPixelProvider>
        </AnalyticsProvider>
      </FirebaseProvider>
    </BrowserRouter>
  );
}

export default App;
